/* eslint-disable */
import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import {
  MainContainer,
  ChatContainer,
  MessageList,
  Message,
  MessageInput,
  ConversationHeader,
  Avatar,
  Conversation,
  ConversationList,
  Search,
} from '@chatscope/chat-ui-kit-react';
import { readChat } from '~/store/chat/actions';
import equipImagePicker from './equipImageSelector';
import { Alert } from '@material-ui/lab';
import { Collapse } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import "@chatscope/chat-ui-kit-styles/dist/default/styles.min.css";
import './chat.css';

const messageConstructor = (message, senderName, senderID, room) => ({
  message,
  sender: {
    web_user_id: senderID,
    operator_name: senderName,
    room,
  },
});

const ChatTab = ({ selectedChatId: defaultSelectedChatId }) => {
  const [searchChat, setSearchChat] = useState('');
  const [chatContent, setChatContent] = useState('');
  const [openAlert, setOpenAlert] = useState(false);
  const dispatch = useDispatch();
  const allChats = useSelector(state => state.chat.chatList);
  const chatList = useMemo(() => {
    return Object.fromEntries(
      Object.entries(allChats).filter(([_, chat]) => chat.active === 1)
    );
  }, [allChats]);
  const [selectedChat, setSelectedChat] = useState(() => chatList ? defaultSelectedChatId : null);
  const connectionStatus = useSelector(state => state.chat.connectionStatus);
  const platformUser = useSelector(state => state.auth.user);
  const socket = useSelector(state => state.chat.socketConnection);
  
  const requestRoomHistory = (roomId) => {
    socket.emit('request_room_history', { room: roomId }, () => {
    });
  };

  useEffect(() => {
    if (!defaultSelectedChatId) return;

    requestRoomHistory(defaultSelectedChatId)
  }, [defaultSelectedChatId])

  const messageInputRef = React.createRef();

  const { t: translate } = useTranslation();

  const handleChatUpdate = (value) => {
    if (value.length > 256) {
      setOpenAlert(true);
      return setChatContent(value.slice(0, 256));
    }
    setOpenAlert(false);
    return setChatContent(value.slice(0, 256));
  }

  const sendNewMessage = (message) => {
    const msg = messageConstructor(message, platformUser.username, platformUser.id, selectedChat)  
    
    socket.emit('platform_to_tablet_message', {...msg, room: selectedChat}, () => {
    });
    setChatContent('');
  };

  const equipmentConnectionStatus = (id) => {
    if (!chatList[id].isReaded) {
      dispatch(readChat(id));
    } 
    return connectionStatus && connectionStatus[id] ? 'available' : 'unavailable';
  };
  const searchedChats = Object.values(chatList || {})
    .filter(e => searchChat === '' || e.name.toLowerCase()
    .includes(searchChat.toLowerCase()));
  return (
    <div style={{ height: '100%', maxHeight: '800px', minHeight: '250px' }}>
      <MainContainer className="main-container">
        {!defaultSelectedChatId && (
        <ConversationList className="conversationList">
          <div style={{ width: '95%', margin: '5px' }}>
            <Search
            placeholder="Search..."
            value={searchChat}
            onChange={v => setSearchChat(v)}
            onClearClick={() => setSearchChat('')}
          />
          </div>
          {searchedChats
            .sort((a, b) => {
              const aStatus = connectionStatus?.[a.id] ? 1 : 0;
              const bStatus = connectionStatus?.[b.id] ? 1 : 0;
              if (aStatus !== bStatus) return bStatus - aStatus;
              return Number(a.isReaded) - Number(b.isReaded);
            })
            .map(e => (
              <Conversation
                key={e.id}
                name={e.name}
                className={selectedChat && e.id === selectedChat ? 'cs-selected' : ''}
                unreadDot={!e.isReaded}
                onClick={() => {
                  setSelectedChat(e.id);
                  requestRoomHistory(e.id);
                  dispatch(readChat(e.id));
                }}
              >
                <Avatar
                  src={equipImagePicker(e.id_equip)}
                  name={e.name}
                  status={connectionStatus?.[e.id] ? 'available' : 'unavailable'}
                />
              </Conversation>
          ))}
        </ConversationList>
        )}
        {chatList?.[selectedChat] && (
          <ChatContainer className={defaultSelectedChatId ? 'modal-chat' : ''}>
            <ConversationHeader className="conversation-header">
              <Avatar
                src={equipImagePicker(chatList[selectedChat].id_equip)}
                name={chatList[selectedChat].name}
                status={equipmentConnectionStatus(chatList[selectedChat].id)}
              />
              <ConversationHeader.Content userName={chatList[selectedChat].name} />
            </ConversationHeader>
            <MessageList className="message-container">
              {chatList[selectedChat] && chatList[selectedChat].messages?.map(equipChat => (
                <Message
                  key={equipChat.id}
                  model={{
                    message: `${equipChat.sender.operator_name}: ${equipChat.message}`,
                    sender: equipChat.sender.operator_name,
                    direction: equipChat.type === 'received' ? 'incoming' : 'outgoing',
                  }}
                  className={equipChat.type === 'received' ? 'message-incoming' : 'message-outgoing'}
                />
              ))}
            </MessageList>
            <div as={MessageInput}>
              <Collapse in={openAlert}>
                <Alert severity='error' className='chat-alert'>
                  {translate('tips:CharacterLimitExceeded')}
                </Alert>
              </Collapse>
              <MessageInput
                ref={messageInputRef}
                attachButton={false}
                value={chatContent}
                onChange={(_, textContent) => handleChatUpdate(textContent)}
                placeholder={translate('common:TypeAMessage')
                }
                onSend={(_innerHTML, _) => {
                  sendNewMessage(chatContent);
                }}
                disabled={false}
              />
            </div>
          </ChatContainer>
        )}
      </MainContainer>
    </div>
  );
};

ChatTab.propTypes = {
  selectedChatId: PropTypes.number,
};

ChatTab.defaultProps = {
  selectedChatId: null,
};

export default ChatTab;
